import React from "react";
import { Box, Typography, Paper } from "@mui/material";

const RidesTab: React.FC = () => {
  return (
    <Box
      sx={{
        bgcolor: "#ffffffff",
        minHeight: "50vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        p: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 6,
          borderRadius: "16px",
          textAlign: "center",
          maxWidth: 500,
          width: "100%",
          bgcolor: "#ffffff",
        }}
      >
        <Typography
          variant="h4"
          fontWeight={700}
          gutterBottom
          sx={{ color: "#222" }}
        >
          Welcome to Rides
        </Typography>
      </Paper>
    </Box>
  );
};

export default RidesTab;
